export const ALLOWED_CONTENT_TYPES = /^(image\/(jpeg|png|gif)|video\/mp4)$/;

export const MAX_UPLOAD_BYTES = 20 * 1024 * 1024;

const MAX_UPLOAD_LABEL = `${MAX_UPLOAD_BYTES / (1024 * 1024)}MB`;

export const uploadRejection = (file: Blob, contentType: string): string | null => {
  if (!ALLOWED_CONTENT_TYPES.test(contentType)) {
    return 'Unsupported file type. Use a JPG, PNG, GIF or MP4.';
  }
  if (file.size > MAX_UPLOAD_BYTES) {
    return `File is too large. The limit is ${MAX_UPLOAD_LABEL}.`;
  }
  return null;
};
